import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=3bd76ddc&scoped=true&"
import script from "./side-menu.vue?vue&type=script&lang=js&"
export * from "./side-menu.vue?vue&type=script&lang=js&"
import style0 from "./styles/side-menu.scss?vue&type=style&index=0&id=3bd76ddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd76ddc",
  null
  
)

component.options.__file = "side-menu.vue"
export default component.exports